import React, { ChangeEvent } from 'react';

interface PropType {
    name: string;
    value: string | null | undefined;
    height?: string;
    hint?: string;
    placeholder?: string;
    onChangeHandler: (value: any, name: string) => void;
}

const InputTextarea = (props: PropType) => {
    return (
        <>
            <textarea
                value={props.value ? props.value : ''}
                onChange={(e: ChangeEvent<any>) => { props.onChangeHandler(e.currentTarget.value, props.name); }}
                className="form-control"
                placeholder={props.placeholder}
                name={props.name}
                style={{minHeight: props.height, resize: 'vertical', maxHeight: '1000px'}}
            />
            {props.hint && <span className="form-text m-b-none">{props.hint}</span>}
        </>
    );
};

export default InputTextarea;



// WEBPACK FOOTER //
// ./src/components/Form/InputTextarea.tsx